import { Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, MensajeError } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ordenMaquilaPdf from "../../../../Pdf/ordenMaquilaPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfOrdenMaquila extends Component {
  iframeRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    folio: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible && this.props.ordenId) {
        this.consultarDatosPdf();
      } else if (!this.props.visible) {
        this.setState({ pdf: null, folio: null });
      }
    }
  }

  consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/datosPdfOrdenMaquila",
        { ordenId: this.props.ordenId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.message || "No se pudo generar el PDF de la orden" });
          this.setState({ loading: false });
          return;
        }
        const pdf = pdfMake.createPdf(ordenMaquilaPdf(res.data));
        this.setState({ loading: false, pdf, folio: res.data.orden?.folio }, () => this.abrirEnIframe(pdf));
      })
      .catch(() => {
        MensajeError({ message: "Hubo un error y no se pudo generar el PDF de la orden" });
        this.setState({ loading: false });
      });
  }

  abrirEnIframe(pdf, intento = 0) {
    const frame = this.iframeRef.current?.contentWindow || window.frames["OrdenMaquilaPdfIframe"];
    if (frame) {
      pdf.open({}, frame);
      return;
    }
    if (intento < 10) {
      setTimeout(() => this.abrirEnIframe(pdf, intento + 1), 100);
    }
  }

  descargarPdf() {
    if (this.state.pdf) {
      this.state.pdf.download(`OrdenMaquila_${this.state.folio || "orden"}.pdf`);
    }
  }

  render() {
    return (
      <ModalItem
        title={`Orden de maquila${this.state.folio ? " — " + this.state.folio : ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <Space>
            <ButtonItem icon={<DownloadOutlined />} type="primary" disabled={!this.state.pdf} onClick={() => this.descargarPdf()}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem rojo onClick={this.props.onCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          ref={this.iframeRef}
          title="Orden de maquila PDF"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="OrdenMaquilaPdfIframe"
          name="OrdenMaquilaPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPdfOrdenMaquila);
